export default "__VITE_ASSET__IMc4LxNh__"